// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize

// https://github.com/babel/babel/blob/3deb246c7d9a7d4d0143ca7276966a0b43e69d53/packages/babel-preset-env/data/built-in-features.js#L154
// Polyfills don't implement as it requires a large dictionary
if (typeof String.prototype.normalize !== 'function') {
  String.prototype.normalize = function () {  // eslint-disable-line no-extend-native
    return String(this).toLowerCase()
  }
}



// WEBPACK FOOTER //
// ./src/polyfills.js